import styled from 'styled-components';
import { BaseSection } from '../components/styles';

export const Container = styled.div`
  position: relative;
  #id-homepage-supplier-image-1 {
    object-fit: cover;
    object-position: 79%;
  }
  #id-homepage-supplier-image-2 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-supplier-image-3 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-supplier-image-4 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-supplier-image-5 {
    object-fit: cover;
    object-position: 90%;
  }
`;

export const FirstSection = styled(BaseSection)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.white};
  text-align: left;
  padding-top: 6rem;

  > button {
    align-items: center;
  }

  > div {
    gap: 1rem;
  }
`;

export const ImageLine = styled.img`
  position: absolute;
  width: 100%;
  height: 270px;
  margin: 0 0 0 0rem;
  top: 725px;
  left: -5px;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    align-items: center;
    width: 100%;
    top: 800px;
    left: 0px;
    height: 100px;
  }
`;

